import { MenuItem } from 'primereact/menuitem';

export type MenuDropdownProps = {
  menuItems: MenuItem[];
  menuDropdownStyle?: string;
  dotsStyle?: string;
};

export enum PopupAlignment {
  LEFT = 'Left',
  RIGHT = 'right',
}

export type MenuDropdownItemProps = {
  items: { label: string; additionalClasses?: string; onClick: () => void }[];
  menuDropdownStyle?: string;
  dotsStyle?: string;
};
